import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PAGE_TITLE_ID, usePageTitle } from "../app/pageTitle";

// The route refusal, rendered in place of the page (src/app/RequireRole, `denied="forbidden"`).
//
// It stays INSIDE the shell — nav, top bar and language switcher all still there — which is the whole
// difference between this and the two terminal screens in src/auth/tenantAccess.tsx. Those replace the
// router because NOTHING in the tenant answers any more; here exactly one surface is refused and
// everything else the reader holds still works, so the way out is the rail they are already looking at.
//
// THE HEADING. The shell's <h1> is fed by the route's `handle`, which names the page that was asked for
// ("Muutosohjelmat") — the wrong thing to print over a refusal, since it reads as the page having
// loaded. So the title is OVERRIDDEN through the same channel a detail page uses for its data-borne name
// (usePageTitle): the bar says "Ei käyttöoikeutta", and the region below borrows that heading for its
// accessible name. Nothing here draws an <h1> of its own — src/app/page-title.test.mjs fails the build
// on a page that does.
//
// WHAT IT MAY NOT SAY. Not "the page does not exist" (that is NotFoundPage, and it would send the reader
// looking for a URL rather than for a grant) and not "sign in again" (the session is valid — a stale
// token is the 401 path in src/lib/api.ts and never reaches here). What it says is the one true thing:
// this surface needs a right this account does not have in this organisation, and who to ask for it.
export function ForbiddenPage() {
  const { t } = useTranslation();
  usePageTitle(t("states.accessDenied"));

  return (
    <section className="not-found" aria-labelledby={PAGE_TITLE_ID} data-testid="access-denied">
      {/* `role="alert"` for the same reason the tenant screens use it: the reader navigated here
          expecting a page, and the sentence explaining that they did not get one is the only new
          information on screen. */}
      <p className="empty-state" role="alert">
        {t("states.accessDeniedBody")}
      </p>
      <Link to="/">{t("notFound.backHome")}</Link>
    </section>
  );
}
